import { defineNuxtPlugin } from '#app/nuxt'
import { LazyDjBanner, LazyDjBreadCrumb, LazyDjGhostBtn, LazyDjImage, LazyDjImageZoom, LazyAuthLayout, LazyBlankLayout, LazyDefaultLayout, LazyDjAddProductForm, LazyDjAddToBuyingListButton, LazyDjAddToCartButton, LazyDjAddToQuoteButton, LazyDjAddressSelect, LazyDjAddresses, LazyDjCarousel, LazyDjCategoryCollapsible, LazyDjCollapsibleMenu, LazyDjComment, LazyDjComments, LazyDjContactProfile, LazyDjCurrencySwitcher, LazyDjFaq, LazyDjFeatureItem, LazyDjFilteredLinkItem, LazyDjFooterBottom, LazyDjHeaderBottom, LazyDjHeaderMain, LazyDjIconWithText, LazyDjLangSwitcher, LazyDjMessages, LazyDjProductCartCard, LazyDjProductDescriptionSection, LazyDjProductFeaturesSection, LazyDjProductQuoteCard, LazyDjProductSearchResult, LazyDjProductSearchResultVariant, LazyDjProductTitleSection, LazyDjProductVariantInfo, LazyDjQuantity, LazyDjReassuranceList, LazyDjSearchBar, LazyDjSlideItem, LazyDjSplitHeroSection, LazyDjStep, LazyDjSteps, LazyDjTabs, LazyDjAccountLayout, LazyDjBuyingListItem, LazyDjCartActions, LazyDjCartLineTable, LazyDjCartMiniProducts, LazyDjCartProducts, LazyDjCartSummary, LazyDjContactReference, LazyDjFilteredLinkSlider, LazyDjFooter, LazyDjHeader, LazyDjProductActionsSection, LazyDjProductCardHorizontal, LazyDjProductCardVertical, LazyDjProductImageGallery, LazyDjProductInfo, LazyDjProductPrice, LazyDjProductVariantsTable, LazyDjProductsList, LazyDjQuoteDetail, LazyDjQuoteLineTable, LazyDjRelatedProductCardVertical, LazyDjShippingActions, LazyDjWorkflow, LazyDjAddressesPage, LazyDjBuyingListPage, LazyDjCustomerAccountPage, LazyDjProfilePage, LazyDjPageForgetPassword, LazyDjPageGetAccess, LazyDjPageLogin, LazyDjPageLogout, LazyDjPageResetPassword, LazyDjPageValidation, LazyDjCartPage, LazyDjCollectionCategoryPage, LazyDjCollectionPage, LazyDjFastCartPage, LazyDjHomePage, LazyDjProductPage, LazyDjQuoteOrderConfirmationPage, LazyDjServicesPage, LazyDjShippingPage, LazyDjBrandsList, LazyDjCartLayer, LazyDjCheckoutAddressSection, LazyDjCheckoutCustomSection, LazyDjHeroSection, LazyDjHpSlider, LazyDjRelatedProducts, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["DjBanner", LazyDjBanner],
["DjBreadCrumb", LazyDjBreadCrumb],
["DjGhostBtn", LazyDjGhostBtn],
["DjImage", LazyDjImage],
["DjImageZoom", LazyDjImageZoom],
["AuthLayout", LazyAuthLayout],
["BlankLayout", LazyBlankLayout],
["DefaultLayout", LazyDefaultLayout],
["DjAddProductForm", LazyDjAddProductForm],
["DjAddToBuyingListButton", LazyDjAddToBuyingListButton],
["DjAddToCartButton", LazyDjAddToCartButton],
["DjAddToQuoteButton", LazyDjAddToQuoteButton],
["DjAddressSelect", LazyDjAddressSelect],
["DjAddresses", LazyDjAddresses],
["DjCarousel", LazyDjCarousel],
["DjCategoryCollapsible", LazyDjCategoryCollapsible],
["DjCollapsibleMenu", LazyDjCollapsibleMenu],
["DjComment", LazyDjComment],
["DjComments", LazyDjComments],
["DjContactProfile", LazyDjContactProfile],
["DjCurrencySwitcher", LazyDjCurrencySwitcher],
["DjFaq", LazyDjFaq],
["DjFeatureItem", LazyDjFeatureItem],
["DjFilteredLinkItem", LazyDjFilteredLinkItem],
["DjFooterBottom", LazyDjFooterBottom],
["DjHeaderBottom", LazyDjHeaderBottom],
["DjHeaderMain", LazyDjHeaderMain],
["DjIconWithText", LazyDjIconWithText],
["DjLangSwitcher", LazyDjLangSwitcher],
["DjMessages", LazyDjMessages],
["DjProductCartCard", LazyDjProductCartCard],
["DjProductDescriptionSection", LazyDjProductDescriptionSection],
["DjProductFeaturesSection", LazyDjProductFeaturesSection],
["DjProductQuoteCard", LazyDjProductQuoteCard],
["DjProductSearchResult", LazyDjProductSearchResult],
["DjProductSearchResultVariant", LazyDjProductSearchResultVariant],
["DjProductTitleSection", LazyDjProductTitleSection],
["DjProductVariantInfo", LazyDjProductVariantInfo],
["DjQuantity", LazyDjQuantity],
["DjReassuranceList", LazyDjReassuranceList],
["DjSearchBar", LazyDjSearchBar],
["DjSlideItem", LazyDjSlideItem],
["DjSplitHeroSection", LazyDjSplitHeroSection],
["DjStep", LazyDjStep],
["DjSteps", LazyDjSteps],
["DjTabs", LazyDjTabs],
["DjAccountLayout", LazyDjAccountLayout],
["DjBuyingListItem", LazyDjBuyingListItem],
["DjCartActions", LazyDjCartActions],
["DjCartLineTable", LazyDjCartLineTable],
["DjCartMiniProducts", LazyDjCartMiniProducts],
["DjCartProducts", LazyDjCartProducts],
["DjCartSummary", LazyDjCartSummary],
["DjContactReference", LazyDjContactReference],
["DjFilteredLinkSlider", LazyDjFilteredLinkSlider],
["DjFooter", LazyDjFooter],
["DjHeader", LazyDjHeader],
["DjProductActionsSection", LazyDjProductActionsSection],
["DjProductCardHorizontal", LazyDjProductCardHorizontal],
["DjProductCardVertical", LazyDjProductCardVertical],
["DjProductImageGallery", LazyDjProductImageGallery],
["DjProductInfo", LazyDjProductInfo],
["DjProductPrice", LazyDjProductPrice],
["DjProductVariantsTable", LazyDjProductVariantsTable],
["DjProductsList", LazyDjProductsList],
["DjQuoteDetail", LazyDjQuoteDetail],
["DjQuoteLineTable", LazyDjQuoteLineTable],
["DjRelatedProductCardVertical", LazyDjRelatedProductCardVertical],
["DjShippingActions", LazyDjShippingActions],
["DjWorkflow", LazyDjWorkflow],
["DjAddressesPage", LazyDjAddressesPage],
["DjBuyingListPage", LazyDjBuyingListPage],
["DjCustomerAccountPage", LazyDjCustomerAccountPage],
["DjProfilePage", LazyDjProfilePage],
["DjPageForgetPassword", LazyDjPageForgetPassword],
["DjPageGetAccess", LazyDjPageGetAccess],
["DjPageLogin", LazyDjPageLogin],
["DjPageLogout", LazyDjPageLogout],
["DjPageResetPassword", LazyDjPageResetPassword],
["DjPageValidation", LazyDjPageValidation],
["DjCartPage", LazyDjCartPage],
["DjCollectionCategoryPage", LazyDjCollectionCategoryPage],
["DjCollectionPage", LazyDjCollectionPage],
["DjFastCartPage", LazyDjFastCartPage],
["DjHomePage", LazyDjHomePage],
["DjProductPage", LazyDjProductPage],
["DjQuoteOrderConfirmationPage", LazyDjQuoteOrderConfirmationPage],
["DjServicesPage", LazyDjServicesPage],
["DjShippingPage", LazyDjShippingPage],
["DjBrandsList", LazyDjBrandsList],
["DjCartLayer", LazyDjCartLayer],
["DjCheckoutAddressSection", LazyDjCheckoutAddressSection],
["DjCheckoutCustomSection", LazyDjCheckoutCustomSection],
["DjHeroSection", LazyDjHeroSection],
["DjHpSlider", LazyDjHpSlider],
["DjRelatedProducts", LazyDjRelatedProducts],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
